import { create } from "zustand"

import type { ThreadLock, ThreadLockHolder } from "@productlane/lib"

interface ThreadLockState {
	locks: Record<string, ThreadLockHolder>
	heldThreadId: string | null
	setLocks: (locks: ThreadLock[]) => void
	setHeldThreadId: (threadId: string | null) => void
}

export const useThreadLockState = create<ThreadLockState>()((set) => ({
	locks: {},
	heldThreadId: null,
	setLocks: (locks) =>
		set({
			locks: Object.fromEntries(
				locks.map(({ threadId, ...holder }) => [threadId, holder]),
			),
		}),
	setHeldThreadId: (threadId) => set({ heldThreadId: threadId }),
}))

/**
 * The teammate holding this thread, or null when it is free or held by the
 * reader themselves.
 */
export function useThreadLockedBy(
	threadId: string | undefined,
	currentUserId: string | undefined,
): ThreadLockHolder | null {
	return useThreadLockState((state) => {
		if (!threadId) return null
		const holder = state.locks[threadId]
		if (!holder || holder.userId === currentUserId) return null
		return holder
	})
}
